export const products = [
  { id: 1, name: "Internet" },
  { id: 2, name: "Telefone" },
  { id: 3, name: "Wifi Plus" },
  { id: 4, name: "Seguro Proteção Vida" },
  { id: 5, name: "Seguro Conexão Garantida" },
];